
import { useScenario} from "../../contexts/ScenarioContext"

import RevealTable from "../RevealTable"

const CirculationTabContent = () => {
    const { circulationFindings } = useScenario()

           
    return (
            <RevealTable
                title="Circulation"
                category="circulation"
                headings={["Assessments", "Current Value"]}
                rows={circulationFindings}
            />
        )

}
export default CirculationTabContent